import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import React, { useEffect, useState, useRef } from 'react';
import InfoTooltipTemplate from '../InfoTooltipTemplate';

/**
 * A customizable text input template
 */
const TextInputTemplate = ({
    name,
    label,
    disabled,
    className,
    labelClassName,
    floatLabel,
    noMargins,
    bottomMargin,
    inline,
    value,
    placeholder,
    onChangeFunction,
    isValid,
    errorMessage,
    category,
    infoMessage,
    focusInput,
    selectInput,
    onKeyUp,
    clickable,
    autoComplete
}) => {
    const inputRef = useRef();
    const [inputClasses, setInputClasses] = useState(classNames({
        'p-invalid': isValid,
        'w-full': true
    }));
    const [labelClasses, setLabelClasses] = useState(classNames({
        'p-error': isValid,
        'w-full': true,
        'block mb-2': !inline,
        'mr-2': inline,
        'pr-4': infoMessage
    }));


    useEffect(() => {
        // add input classes (if we have any)
        if (className) {
            setInputClasses(inputClasses + ' ' + className);
        }

        // add label classes (if we have any)
        if (labelClassName) {
            setLabelClasses(labelClasses + ' ' + labelClassName);
        }

        // focus on input on load
        if (focusInput) {
            inputRef.current.focus();
        }

        // select all input on load
        if(selectInput) {
            inputRef.current.select();
        }
    }, []);

    const inputField = <InputText id={name} value={value} disabled={disabled} placeholder={placeholder} autoComplete={autoComplete} onChange={(e) => onChangeFunction(name, e.target.value, category)} onKeyUp={onKeyUp} className={inputClasses} ref={inputRef} />;

    return (
        <div className={(!noMargins ? ('mb-' + (bottomMargin || '5')) : '')  + (infoMessage ? ' relative' : '')}>
            {floatLabel
                ? <>
                    <span className="p-float-label">
                        {inputField}
                        <label htmlFor={name} className={labelClasses}>{label}</label>
                        {infoMessage && <div className="top-right-icon">
                            <InfoTooltipTemplate target={'tooltip-' + name} message={infoMessage} className="ml-2" />
                        </div>}
                    </span>

                    {errorMessage}
                </>

                : <>
                    <label htmlFor={name} className={labelClasses} title={labelClassName === 'one-line' ? label : null}>{label}</label>
                    {infoMessage && <div className="top-right-icon">
                        <InfoTooltipTemplate target={'tooltip-' + name} message={infoMessage} className="ml-2"/>
                    </div>}
                    {(clickable && value)
                        ? <>
                            <a href={value} target={"_blank"}>{inputField}</a>
                        </>
                        : <>
                            {inputField}
                            {errorMessage}
                        </>
                    }
                </>
            }
        </div>
    );
};

export default TextInputTemplate;
